import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import TextArea from "../../components/shared/TextArea";


const NotificationAddPage = () => {

    const {t,i18n} = useTranslation();
    useDocumentTitle('تنبيه جديد');
    const navigate = useNavigate();
    const pageTitle = {title: 'تنبيه جديد', subTitle: 'يمكنك إضافة تنبيه جديد من هنا.'};
    const EmptyAddNotificationForm = {
        roles: null,
        users: [],
        title: {ar:'', en:''},
        body: {ar:'', en:''}
    };
    const [addNotificationForm,setAddNotificationForm] = useState(EmptyAddNotificationForm);
    const [errors, setErrors] = useState(null);
    const [isAddNotificationFormDisabled, setIsAddNotificationFormDisabled] = useState(true);

    const [toggleAllRole, setToggleAllRole] = useState(false);

    const [allUsers, setAllUsers] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const handleSubmitAddNotification = async () => {
        setIsAddNotificationFormDisabled(true);
        const finalAddNotificationForm = JSON.parse(JSON.stringify(addNotificationForm));
        if(toggleAllRole) {
            delete finalAddNotificationForm.users;
        }
        try {
        const response = await apiClient.post(`/b-notifications`,finalAddNotificationForm);
        if(response?.data || response?.status === 201) {
            navigate(`/ar/notifications-center`);
        } else {
            setIsAddNotificationFormDisabled(false);
        }
        } catch(err) {
            setIsAddNotificationFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(addNotificationForm 
            && addNotificationForm?.roles && addNotificationForm?.roles !== ''
            && addNotificationForm?.title && addNotificationForm?.title?.ar !== '' && addNotificationForm?.title?.en !== ''
            && addNotificationForm?.body && addNotificationForm?.body?.ar !== '' && addNotificationForm?.body?.en !== '') {
                if(!toggleAllRole && addNotificationForm?.users?.length > 0) {
                    setIsAddNotificationFormDisabled(false);
                } else if(toggleAllRole) {
                    setIsAddNotificationFormDisabled(false);
                } else {
                    setIsAddNotificationFormDisabled(true);
                }
        } else {
            setIsAddNotificationFormDisabled(true);
        }
    },[addNotificationForm, toggleAllRole])


    const useRolesOptions = [
        // {label:'المدراء', value:'ADMINISTRATOR'},
        // {label:'الموظفين', value:'EMPLOYEE'},
        {label:'المستفيدين', value:'BENEFICIARY'}
    ]

    const getAllUsers = async () => {
      try {
        const response = await apiClient.get(`/b-users`);
        if(response?.data) {
          setAllUsers(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        getAllUsers();
    },[])

    useEffect(()=>{
        if(addNotificationForm?.roles) {
            setSelectedUsers(allUsers?.filter(user =>  user?.role?.id === addNotificationForm?.roles).map(user => ({label: user?.name, value: user?._id})));
        }
    },[addNotificationForm?.roles])


    

    return (
        <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <span className="fixed top-0 left-0 right-0 bottom-0 z-[-1] bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإرسال تنبيه جديد." label="أضف تنبيه جديد ">
                    
                    <div className="mb-[15px]">
                        <MultiSelect label={'الفئة المستهدفة'} placeholder={'اختر الفئة المستهدفة'} options={useRolesOptions} error={errors?.roles} errorMessage={errors?.roles} value={addNotificationForm?.roles} onChange={(option)=>{setAddNotificationForm({ ...addNotificationForm, roles: option?.value }); hideError('roles')}} />
                    </div>

                    {/* {addNotificationForm?.roles && <div className="text-[16px] font-[500] text-grey-600 mt-[-5px] cursor-pointer select-none mb-[15px]" onClick={()=>setToggleAllRole(!toggleAllRole)}>
                        <span className="inline-block align-middle w-[24px] h-[24px] me-[5px]" style={{ background: toggleAllRole ? "url('/assets/images/toggle-on.svg')" : "url('/assets/images/toggle-off.svg')" }}></span>
                        إرسال لجميع جهات الفئة المستهدفة
                    </div>} */}

                    {!toggleAllRole && addNotificationForm?.roles && <div className="mb-[15px]">
                        <MultiSelect label={'اسماء المستهدفين'} placeholder={'اختر المستخدمين المستهدفين'} isMulti options={selectedUsers} error={errors?.roles} errorMessage={errors?.roles} value={addNotificationForm?.users} onChange={(options)=>{setAddNotificationForm({ ...addNotificationForm, users: options?.map(option => option?.value) }); hideError('roles')}} />
                    </div>}

                    <div className="mb-[15px]">
                        <InputField label={'العنوان'} placeholder={'اكتب عنوان التنبيه'} value={addNotificationForm?.title?.ar} error={errors?.title} errorMessage={errors?.title} translateError={true} onChange={(e)=>{setAddNotificationForm({ ...addNotificationForm, title: {ar: e.target.value, en: e.target.value} }); hideError('title')}} />
                    </div>

                    <div className="mb-[15px]">
                        <TextArea label={'رسالة التنبيه'} placeholder={'اكتب رساله التنبيه'} value={addNotificationForm?.body?.ar} error={errors?.body} errorMessage={errors?.body} translateError={true} onChange={(e)=>{ setAddNotificationForm({ ...addNotificationForm, body:{ar: e.target.value, en: e.target.value} }); hideError('body')}} />
                    </div>


                    

                    <div className="text-end">
                        <NormalButton label={'ارسال التنبيه'} onClick={handleSubmitAddNotification} isDisabled={isAddNotificationFormDisabled} />
                    </div>

                </NormalFormContainer>
            </MainContent>
        </PageMain>
        </div>
    )

}

export default NotificationAddPage;